import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

type AvatarStyleProps = {
  color: string;
};

export const Avatar = styled.div<AvatarStyleProps>`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  svg {
    color: ${COLOR.WHITE};
    width: 24px;
    font-size: 18px;
  }
`;
